import { createContext } from 'react';
import { SecurityFlags, defaultSecurityFlags } from 'types/SecurityFlags';

export const UserPermissionsContext = createContext<SecurityFlags>(defaultSecurityFlags);